<article>
  @defer (when stats()) {
    <div class="flex">
      <div>
        <div>
          <div class="stat-container">
            <div>Open</div>
            <div>{{ stats().counts.open }}</div>
          </div>
        </div>
      </div>
      <div>
        <div>
          <div class="stat-container">
            <div>New last 28 days</div>
            <div>{{ stats().counts.new_last_28 }}</div>
          </div>
        </div>
      </div>
      <div>
        <div>
          <div class="stat-container">
            <div>Closed last 28 days</div>
            <div>{{ stats().counts.closed_last_28 }}</div>
          </div>
        </div>
      </div>
      <div>
        <div>
          <div class="stat-container">
            <div>Avg days to close</div>
            <div>
              @if (stats().counts.avg_time_to_close < 1) {
                same day
              } @else {
                {{ stats().counts.avg_time_to_close | number: '1.1-2' }}
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  } @placeholder {
    <div class="flex">
      <div class="">
        <div>
          <div>...</div>
          <div>...</div>
        </div>
      </div>
      <div class="">
        <div>
          <div>...</div>
          <div>...</div>
        </div>
      </div>
      <div class="">
        <div>
          <div>...</div>
          <div>...</div>
        </div>
      </div>
      <div class="">
        <div>
          <div>...</div>
          <div>...</div>
        </div>
      </div>
    </div>
  }
</article>
